import React, {useState} from 'react';
//material
import {Container, withStyles, Grid, Button} from '@material-ui/core';
//styles
import styles from './my-meetings-styles';
//components
import MeetingItem from '../../../components/events/meeting-item';
import PageHeading from '../../../components/page-heading';
import {Skeleton} from "@material-ui/lab";

const MyMeetingsView = (props) => {
  const {classes, isLoading, meetings, pastMeetings, showMeetings} = props;
  const [showPast, setShowPast] = useState(false);
  const myMeetings = showPast ? pastMeetings : meetings;

  return (
    <Container maxWidth={'md'}>
      <PageHeading heading={showMeetings.current ? 'My Meetings' : 'My Events'}/>

      <Grid container className={classes.gridContainer}>
        {
          isLoading ?
            <div className={classes.buttonContainer}><Skeleton width={'30%'}/></div>  :
            <Grid item xs={12} className={classes.buttonContainer}>
              <Button color={'primary'} variant={showPast ? 'outlined' : 'contained'} onClick={() => setShowPast(false)} classes={{root: classes.viewButton}}>Current</Button>
              <Button color={'primary'} variant={!showPast ? 'outlined' : 'contained'} onClick={() => setShowPast(true)} classes={{root: classes.viewButton}}>Past</Button>
            </Grid>
        }

        <Grid container spacing={2}>
          {
            !isLoading && myMeetings.map((m, i) =>
              <Grid key={i} item xs={12} sm={4}>
                <MeetingItem
                  meeting={m}
                  showMeetings={showMeetings.current}/>
              </Grid>)
          }

          {
            isLoading &&
            <>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
              <Grid item xs={12} sm={4}><MeetingItem isLoading/></Grid>
            </>
          }

          {
            !isLoading && myMeetings.length === 0 &&
            <div className={classes.noEvents}>
              No {showMeetings.current ? 'Meetings' : 'Events'} to show
            </div>
          }
        </Grid>
      </Grid>
    </Container>
  );
};

export default withStyles(styles) (MyMeetingsView);
